module.exports = __webpack_public_path__ + "img/cloud-bg.b6112366.png";